var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useListItem } from '@floating-ui/react';
import { useFocusRing } from 'react-aria';
import { Text } from '../text';
import { useDropdown } from './dropdown-context';
import { itemDescriptionStyle, itemInnerContentStyle, itemLabelStyle, itemStyle, } from './styles';
function Item(_a) {
    var { as, decorLeft, decorRight, description, disabled = false, isActive = false, label, onClick, role = 'menuitem', type } = _a, restProps = __rest(_a, ["as", "decorLeft", "decorRight", "description", "disabled", "isActive", "label", "onClick", "role", "type"]);
    const Element = as !== null && as !== void 0 ? as : 'button';
    const { focusProps, isFocusVisible } = useFocusRing();
    const { activeIndex, getItemProps, isListbox, setIsOpen, size, triggerRef } = useDropdown();
    const { index, ref } = useListItem();
    const hasDescription = description != null;
    const internalIsActive = isListbox
        ? isActive || (index === activeIndex && !disabled)
        : isActive;
    function handleClick(event) {
        var _a;
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
        setIsOpen(false);
        // @ts-expect-error: focus() not recognized
        (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
    return (_jsxs(Element, Object.assign({}, getItemProps(Object.assign(Object.assign({ disabled, onClick: handleClick }, focusProps), restProps)), { css: itemStyle({ isActive: internalIsActive, isFocusVisible, size }), ref: ref, role: role, tabIndex: -1, type: type == null && Element === 'button' ? 'button' : type }, (isListbox && {
        'aria-selected': internalIsActive,
        id: `dropdown-item-${index}`,
    }), { children: [decorLeft, _jsxs("span", Object.assign({ css: itemInnerContentStyle({
                    hasDescription,
                    hasLeftDecor: decorLeft != null,
                    hasRightDecor: decorRight != null,
                }) }, { children: [_jsx(Text, Object.assign({ css: itemLabelStyle({
                            hasDescription,
                            isActive: internalIsActive,
                            isVirtual: isListbox,
                        }), size: size }, { children: label })), hasDescription && (_jsx(Text, Object.assign({ css: itemDescriptionStyle({ size }) }, { children: description })))] })), decorRight] })));
}
export default Item;
